module.exports = __webpack_public_path__ + "img/04.c44a0d7b.jpg";